"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = exports.Button = exports.StyledButton = exports.getSiteVariantByName = exports.getSiteTheme = void 0;
var tslib_1 = require("tslib");
var styled_components_1 = require("styled-components");
var React = require("react");
var react_1 = require("react");
var Cta_styled_1 = require("./Cta.styled");
var common_types_1 = require("@next-components/common-types");
exports.getSiteTheme = function (site) {
    var siteTheme = require("./theme/" + site);
    return siteTheme[site + "Theme"];
};
exports.getSiteVariantByName = function (site, variant) {
    var siteTheme = require("./theme/" + site);
    var variantName = "" + site + common_types_1.capitalize(variant) + "Style";
    return siteTheme.hasOwnProperty(variantName) ? siteTheme[variantName] : '';
};
/* Button variants */
exports.StyledButton = styled_components_1.default.button(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  ", "\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n  ", "\n"])), Cta_styled_1.commonStyles, function (props) { return exports.getSiteVariantByName(props.site, props.variant); }, function (props) { return (props.site ? exports.getSiteTheme(props.site) : ''); });
exports.Button = function (props) {
    return React.createElement(exports.StyledButton, tslib_1.__assign({}, props));
};
exports.Button.defaultProps = {
    backgroundDark: false,
    colorVariant: 'brand',
    disabled: false,
    site: common_types_1.Site.bosno,
    variant: 'cta',
};
var StyledLink = react_1.forwardRef(function (_a, ref) {
    var onClick = _a.onClick, href = _a.href, children = _a.children, backgroundDark = _a.backgroundDark, variant = _a.variant, props = tslib_1.__rest(_a, ["onClick", "href", "children", "backgroundDark", "variant"]);
    return (React.createElement("a", tslib_1.__assign({}, props, { href: href, onClick: onClick, ref: ref }), children));
});
/* Link variants */
/* https://nextjs.org/docs/api-reference/next/link#if-the-child-is-a-function-component
 * Because NextJS needs access to the 'a'-tag directly we need to set a ref for the 'a' tag. Thus some fancy wrapping
 * and ref forwarding stuff here.
 **/
exports.Link = styled_components_1.default(StyledLink)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  ", "\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n  ", "\n"])), Cta_styled_1.commonStyles, function (props) { return exports.getSiteVariantByName(props.site, props.variant); }, function (props) { return (props.site ? exports.getSiteTheme(props.site) : ''); });
exports.Link.defaultProps = {
    backgroundDark: false,
    colorVariant: 'brand',
    disabled: false,
    site: common_types_1.Site.bosno,
    variant: 'cta',
    ref: null,
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=Cta.js.map